
import { useState, useEffect } from 'react';

export default function FixedCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      setIsVisible(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 left-6 z-40">
      <a
        href="https://api.whatsapp.com/send/?phone=+523317097105&text=Hola+Dr.+Eduardo+Cabeza+Bucio%2C+me+gustar%C3%ADa+agendar+una+consulta&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white px-6 py-4 rounded-full shadow-2xl hover:opacity-90 transition-all duration-300 transform hover:scale-105 flex items-center space-x-3 whitespace-nowrap cursor-pointer"
        style={{ backgroundColor: '#168B98' }}
      >
        <i className="ri-calendar-check-line text-xl"></i>
        <div className="text-left">
          <div className="font-semibold text-sm">Agenda tu Consulta</div>
        </div>
      </a>
    </div>
  );
}
